export default {
    courses: "courses",
    content: "content",
    tutors: "tutors"
};
